module.exports = __webpack_public_path__ + "static/media/cases_3d_05c.6e33ba94.jpg";